import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import EGiftCardsSplash from '../assets/images/EGift Cards - Splash.png';
import EGiftCardsStreamlined from '../assets/images/EGift Cards - Streamlined Distribution.png';
import EGiftCardsUniversal from '../assets/images/EGift Cards - Universal Appeal.png';


import '../components/GlobalStyle.css';

import { FadeLoad, FadeScroll, FadeLoadDelay } from '../components/styled/Motion.styled';


const ImageMargin = styled.div`
    @media screen and (min-width: 1200px) {
        z-index: -1;
        width: 60%;
        margin: -8rem auto auto;
    }
`

const EGiftCards = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products & Services | EGift Cards</title>
                <link rel="canonical" href="https://bestpayment.solutions/egift-cards" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75'>
                <Row className='pt-5 justify-content-center align-items-center text-center text-lg-start'>
                    <Col lg={5} className='order-2 order-lg-1'>
                        <FadeLoadDelay>
                            <img src={EGiftCardsSplash} width='100%' />
                        </FadeLoadDelay>
                    </Col>
                    <Col lg={5} className='pt-4 pt-lg-0 order-1 order-lg-2'>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>eGift Cards</h2>
                            <h1 className='fs-60'>
                                Personal, practical, & powerful eGift Card incentives
                            </h1>
                        </FadeLoad>
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={4} className='py-5'>
                        <h3 className='fs-24'>Universal appeal</h3>
                        <p>
                            eGift cards stand at the intersection of convenience and choice. This makes them one of the most impactful ways to motivate and reward. Inspire high-performing sales teams or keep your dedicated customer base engaged. No matter the use, eGift cards are a universally cherished incentive.
                        </p>

                        <h3 className='fs-24 pt-4'>Diverse retail choices</h3>
                        <p>
                            Offer your recipients the freedom to shop from their favorite brands like Amazon, Target, or Walmart. You can also dive into enriching experiential rewards with egift cards to travel companies like Booking.com, leaving your recipient with happy life-long memories.
                        </p>
                    </Col>
                    <Col lg={5} className='py-5'>
                        <FadeScroll>
                            <img src={EGiftCardsUniversal} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} className='py-lg-5 order-2 order-md-1'>
                        <FadeScroll>
                            <img src={EGiftCardsStreamlined} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={4} className='py-lg-5 order-1 order-md-2'>
                        <h3 className='fs-24'>Streamlined distribution</h3>
                        <p>
                            From selection to distribution to follow-ups, managing eGift card incentives can be a daunting task. But you needn’t stress over the details. We specialize in seamless eGift card distribution. Your team, customers, and stakeholders receive their rewards promptly and effortlessly.
                        </p>

                        <h3 className='fs-24 pt-4'>Effortless incentivizing</h3>
                        <p>
                            The success of an incentive program often lies in its execution. You’ve got enough on your plate without worrying about your incentive program. From tracking to delivery, entrust us with the intricacies of your program. Then you can sit back and witness the transformative power of well-executed incentives.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5 bg-sky-tint-3'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default EGiftCards;